import 'app/agriculture/routes/BackOffice/UserHome/components/FarmCard/FarmCard.scss';
import { Card } from 'app/agriculture/components/Card/Card';
import '../AddNewFarmCard/AddNewFarmCard.scss';
import classNames from 'classnames';
import { Link, Skeleton } from '@mui/material';

export function FarmCardSkeleton() {
    return (
        <Card className={classNames('FarmCard', 'FarmCards__card')}>
            <Link className="AddNewFarmCard__interactable">
                <div className="AddNewFarmCard__image">
                    <Skeleton variant="circular" />
                </div>
                <div className="AddNewFarmCard__content">
                    <div className="AddNewFarmCard__name">
                        <Skeleton variant="text" width={300} />
                    </div>
                    <div className="AddNewFarmCard__icon">
                        <Skeleton variant="circular" width={20} />
                    </div>
                </div>
            </Link>
        </Card>
    );
}
